import { ChangeEvent } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form';
import { FieldName, FieldProperties, FieldType, FieldValidation } from '@/services/formSchema.service';
import { UseFormSetError } from 'react-hook-form';
import { ApiResponseErrors } from '@/hooks/api/useApi/useApi.interfaces';

export const handleOnChange =
    (
        fieldName: string,
        fieldType: string,
        setValue: UseFormSetValue<any>,
        initialValue: string | boolean,
        fieldProperties: FieldProperties
    ) =>
    (event: ChangeEvent<HTMLInputElement>) => {
        if (fieldType === FieldType.CHECKBOX) {
            setValue(fieldName, event.target.checked);
        }

        if (fieldName === FieldName.PHONE && fieldProperties.additionalFieldProperties.prefix) {
            if (
                event.target.value.length < fieldProperties.additionalFieldProperties.prefix.length ||
                !event.target.value.includes(fieldProperties.additionalFieldProperties.prefix)
            ) {
                setValue(fieldName, fieldProperties.additionalFieldProperties.prefix);
            }
        }
    };

export const getMinLengthValidation = (validation: FieldValidation) =>
    validation.minLength && validation.minLength.value
        ? {
              minLength: {
                  value: validation.minLength.value,
                  message: validation.minLength.message,
              },
          }
        : undefined;

export const getPattern = (validation: FieldValidation) =>
    validation.pattern
        ? {
              value: validation.pattern?.value,
              message: validation.pattern?.message,
          }
        : undefined;

export const getMaxLengthValidation = (validation: FieldValidation) =>
    validation.maxLength && validation.maxLength.value
        ? {
              maxLength: {
                  value: validation.maxLength.value,
                  message: validation.maxLength.message,
              },
          }
        : undefined;

export const getMaxLength = (maxLength?: number) => (maxLength ? maxLength + 1 : undefined);

export const handleAdditionalValidation =
    (watch: UseFormWatch<any>, validation: FieldValidation) => (value: string | FileList) => {
        if (value instanceof FileList) {
            if (validation.additionalPattern?.value) {
                const maxValue = parseInt(validation.additionalPattern.value, 10);

                return value[0].size > maxValue ? validation.additionalPattern?.message : undefined;
            }
        }

        if (validation.additionalPattern && watch(validation.additionalPattern.value) !== value) {
            return validation.additionalPattern.message;
        }
    };

export const handleFormServerErrors = (setErrors: UseFormSetError<any>, errors: ApiResponseErrors) => {
    if (errors.children) {
        for (const [name, properties] of Object.entries(errors.children)) {
            if (properties?.errors) {
                setErrors(name, { type: 'custom', message: properties.errors?.[0] });
            }
        }
    }

    return;
};
